export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ExternalLink.vue?vue&type=template&id=119bbeb2"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ExternalLink.vue?vue&type=template&id=119bbeb2
// module id = 331
// module chunks = 0